'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _players = require('../../store/actions/players');

var mapStateToProps = function mapStateToProps(state, ownProps, _ref) {
  var playerId = _ref.playerId;
  var _state$players$player = state.players[playerId],
      playbackRate = _state$players$player.playbackRate,
      currentQuality = _state$players$player.currentQuality,
      qualities = _state$players$player.qualities,
      qualityChangeLoading = _state$players$player.qualityChangeLoading;


  return {
    currentQuality: currentQuality,
    playbackRate: playbackRate,
    playerId: playerId,
    qualities: qualities,
    qualityChangeLoading: qualityChangeLoading
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps, _ref2) {
  var playerId = _ref2.playerId;

  return {
    setContextMenu: function setContextMenu(contextMenu) {
      return dispatch((0, _players.setContextMenu)(playerId, contextMenu));
    },
    setQuality: function setQuality(quality) {
      return dispatch((0, _players.setQuality)(playerId, quality, true));
    },
    setPlaybackRate: function setPlaybackRate(playbackRate) {
      return dispatch((0, _players.setPlaybackRate)(playerId, playbackRate));
    }
  };
};

exports.default = {
  mapStateToProps: mapStateToProps,
  mapDispatchToProps: mapDispatchToProps
};
module.exports = exports['default'];